import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

const fetchDevotionsDictionary = accountId => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/masses/dictionary`,
});

export const useFetchDevotionsDictionary = () => {
  const accountId = useSelector(selectors.getAccountId);

  const { payload, loading } = useQuery(fetchDevotionsDictionary(accountId));

  return { payload, loading };
};
